<template>
  <div
    class="landing-page-accordion"
    :class="className"
  >
    <div
      v-for="item in items"
      :key="item.title"
      class="landing-page-accordion__item"
      :class="{'landing-page-accordion__item_active': activeItem === item.id}"
      @click="toggle(item.id)"
    >
      <transition
        name="fade-faq"
        mode="out-in"
      >
        <div
          v-if="activeItem === item.id"
          class="landing-page-accordion__shadow"
          :class="{'landing-page-accordion__shadow_top': activeItem === 1}"
        >
          <v-lazy-image
            :src="require('@/assets/images/landing/faq-shadow.svg')"
            :srcPlaceholder="require('@/assets/images/landing/phImage.svg')"
            alt="shadow"
          />
        </div>
      </transition>
      <div class="landing-page-accordion__top">
        <div class="landing-page-accordion__title">
          {{ $t(item.title) }}
        </div>
        <div class="landing-page-accordion__icon">
          <i
            class="ub-icon-arrow-faq"
            :class="{'landing-page-accordion__active': activeItem === item.id}"
          >
          </i>
        </div>
      </div>
      <transition
        name="fade-faq"
        mode="out-in"
      >
        <div
          v-if="activeItem === item.id"
          class="landing-page-accordion__description"
        >
          {{ $t(item.content) }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    className: {
      type: String,
      default: () => '',
    },
  },
  data: () => ({
    activeItem: -1,
  }),
  methods: {
    toggle(id) {
      this.activeItem = this.activeItem === id ? -1 : id;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../sass/variables";
@import "../../../sass/mixins";

.landing-page-accordion {

  &__icon {
    position: absolute;
    right: 31px;
    top: 50%;
    transform: translateY(-50%);
    min-width: 29px;
    max-width: 29px;
    height: 29px;
    border-radius: $borderRadius;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    transition: background-color .15s ease-in;

    i {
      color: $color-shark;
      font-size: $font-size-icon;
      position: relative;
      left: -2px;
      transition: color .15s ease-in;
    }
  }

  &_accordion {
    border-radius: $borderRadiusMiddle;
    background-color: $color-catskill-white;
    padding: 18px 64px 0 64px;

    .landing-page-accordion {

      &__top {
        min-height: 104px;
        max-height: 104px;
        position: relative;
      }

      &__title {
        font: $font-size-landing-medium $font-landing-medium;
        color: $color-shark;
        max-width: 760px;
        padding-left: 40px;
        line-height: 1.4;
      }
    }
  }

  @include mobile {
    margin-top: 25px;
    line-height: 1.5;
  }

  &__top {
    min-height: 74px;
    max-height: 74px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include mobile {
      min-height: 92px;
      max-height: 100%;
      padding-top: 15px;
      padding-bottom: 9px;
    }
  }

  &__shadow {
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 1102px;

    &_top {
      top: -30px;
    }

    img {
      margin: auto;
      display: block;
      max-height: 14px;
    }

    @include tablet-old {
      img {
        position: relative;
        top: 4px;
      }
    }

    @include mobile {
      img {
        display: none;
      }
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    transition: color .15s ease-in;
    position: relative;

    &_active {
      .landing-page-accordion {
        &__title {
          font-family: $font-landing-heavy;
        }

        &__icon {
          background-color: $color-dodger-blue-dark;

          i {
            transform: rotate(-180deg);
            color: $color-white;
            left: 3px;
            top: -3px;

            @include mobile {
              left: 2px;
            }
          }
        }
      }
    }

    &:hover {

      .landing-page-accordion__title {
        color: $color-cornflower-blue;
      }
    }
  }

  &__title {
    color: $color-dodger-blue;
    font: $font-size-landing-md $font-landing-medium;
    position: relative;
    padding-right: 40px;
    transition: color .15s ease-in;

    @include mobile {
      font-size: $font-size-landing-sm;
      padding-right: 55px;
      line-height: 1.5;
    }
  }

  &__description {
    font: $font-size-icon-sm $font-landing-global;
    color: $color-mine-shaft-light;
    height: auto;
    line-height: 1.5;
    width: 100%;
    position: relative;
    top: -10px;
    max-width: 760px;
    padding: 0 40px 35px 40px;

    @include mobile {
      top: 0;
    }
  }

  &__item + &__item {
    border-top: 1px solid $color-link-water;
  }
}

@include tablet-portrait {
  .landing-page-accordion {
    padding: 15px;

    &__title, &__description {
      max-width: 650px !important;
    }

    &__top {
      max-height: 90px !important;
      min-height: 90px !important;
    }
  }
}

@include mobile {
  .landing-page-accordion {
    &_accordion {
      .landing-page-accordion {
        &__title {
          font-size: $font-size-landing-md;
          padding: 0 50px 0 15px !important;
        }

        &__description {
          padding: 0 50px 15px 15px;
          font-size: $font-size-landing-sm;
        }

        &__top {
          min-height: auto !important;
          max-height: none !important;
          padding-bottom: 15px;
        }

        &__icon {
          right: 0;
        }
      }
    }
  }
}
</style>
